const headers = [
  {
    text: 'id',
    value: 'customerId',
    sortable: true,
    width: '1%'
  },
  {
    text: 'sale.sale_status',
    value: 'isEnabled',
    sortable: true,
    width: '6%',
    align: 'center'
  },
  {
    text: 'sale.sale_customer-number',
    value: 'customerNumber',
    sortable: true,
    width: '6%'
  },
  {
    text: 'sale.sale_customer-name',
    value: 'rep',
    sortable: true,
    width: '7%'
  },
  {
    text: 'user.user_alphabet_pinyin',
    value: 'alphabet',
    sortable: true,
    width: '9%'
  },
  {
    text: 'common.input_customer-category',
    value: 'customerCategoryName',
    sortable: true,
    width: '6%'
  },
  {
    text: 'common.common_company-department',
    value: 'organizationAndSection',
    sortable: true,
    width: '7%'
  },
  {
    text: 'jd.jd_store-name',
    value: 'shopName',
    sortable: true,
    width: '7%'
  },
  {
    text: 'common.common_detail-data',
    value: 'details',
    sortable: true,
    width: '12%'
  },
  {
    text: 'common.input_billing-info',
    value: 'billingInfo',
    sortable: true,
    width: '12%'
  },
  {
    text: 'common.input_payment-criteria',
    value: 'paymentCriteria',
    sortable: true,
    width: '6%'
  },
  {
    text: 'common.input_recipient-info',
    value: 'recipient',
    sortable: false,
    width: '13%',
    rowspan: false
  },
  {
    text: 'common.input_sort-number',
    value: 'sortNumber',
    sortable: false,
    width: '6%',
    rowspan: false
  },
  {
    text: 'payment.payment_operation',
    value: 'edit',
    sortable: false,
    width: '6%'
  }
]
export default { headers }
